<template>
  <div>
    <div class="px-5" v-if="variantsPopUpType==='list' || variantsPopUpType===''">
      <!-- <div class="text-center my-5" v-if="loaded">
      <v-pagination :total-visible="10" :circle="true" v-model="page" :length="pageCount"></v-pagination>
      </div>-->

      <loading-block v-if="!loaded"></loading-block>
      <v-data-table
        v-else
        class="py-3 pb-5 tabulardata"
        :headers="headers"
        :items="variantItems"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="editItem(item)"
                v-on="on"
                small
                dark
                color="primary"
                class="mr-2"
                depressed
              >Edit</v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="deleteItem(item)"
                v-on="on"
                small
                dark
                color="primary"
                class="mr-2"
                depressed
              >Delete</v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          <p class="mb-0">No data.</p>
        </template>
      </v-data-table>

      <div class="text-right pt-5" v-if="loaded">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="addNewItem()"
              v-on="on"
              small
              dark
              color="primary"
              class="mr-2"
              depressed
            >Add</v-btn>
          </template>
          <span>Add new variation</span>
        </v-tooltip>
      </div>
    </div>
    <Product-variant-new v-else-if="variantsPopUpType==='add'" />
    <Product-variant-edit v-else-if="variantsPopUpType==='edit'" />
  </div>
</template>
<script>

import { LocationProductAPI } from '@/clients/location/location.product.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import ProductVariantNew from './ProductVariantNew'
import ProductVariantEdit from './ProductVariantEdit'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  components: {
    LoadingBlock,
    ProductVariantNew,
    ProductVariantEdit
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loaded: false,
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Sku', value: 'sku', sortable: true },
        { text: 'Gtin', value: 'gtin', sortable: true },
        { text: 'Price', value: 'price', sortable: true },
        { text: 'Size', value: 'size', sortable: true },
        { text: 'Units', value: 'no_of_units', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false, width: '190' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      activeItem: 'locationproduct/activeItem',
      variantItems: 'locationproduct/variantsList',
      variantsPopUpType: 'locationproduct/variantsPopUpType'
    })
  },
  watch: {
    variantsPopUpType(value) {
      if (value === 'list') {
        this.fetchVaraints(this.activeItem.id)
      }
    }
  },
  created() {
    if (!_.isEmpty(this.activeItem)) {
      this.fetchVaraints(this.activeItem.id)
    };
  },

  methods: {
    /**
     * Fetch and sync variants
     */
    async fetchVaraints() {
      try {
        this.loaded = false
        let res = await LocationProductAPI.fetchVariants(this.activeItem.id)
        this.setVariantsList(res.data.payload)
        this.loaded = true
      } catch (err) {
        this.setVariantsList([])
        this.loaded = true
      }
    },

    /**
     * Function accept object which has an id, return confirm then delete the category
     */
    deleteItem(obj) {
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${obj.sku}.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          try {
            self.spinner(true)
            let res = await LocationProductAPI.deleteVariant(self.activeItem.id, obj.id)
            self.spinner(false)
            if (res.status === 200) {
              self.$swal(
                'Deleted!',
                `${obj.sku} successfully deleted.`,
                'success'
              )

              let res = await LocationProductAPI.fetchVariants(self.activeItem.id)
              self.setVariantsList(res.data.payload)
            } else {
              self.$swal(
                'Failed!',
                'Please try again later.',
                'error'
              )
            }
          } catch (err) {
            self.spinner(false)
            self.snackbar({
              text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
              open: true,
              color: 'error'
            })
          }
        }
      })
    },
    /**
     * Emits events to parent then to Edit component to edit the category
     */
    editItem(obj) {
      this.setVariantsPopUpType('edit')
      this.setVariantEditObj(obj)
    },

    addNewItem() {
      this.setVariantsPopUpType('add')
    },

    closeModal() {
      this.setVariantsPopUp(false)
      this.setVariantsObj({})
      this.setVariantsPopUpType('list')
      this.setVariantsList([])
    },

    ...mapActions({
      setVariantsPopUpType: 'locationproduct/setVariantsPopUpType',
      setVariantsList: 'locationproduct/setVariantsList',
      setVariantEditObj: 'locationproduct/setVariantEditObj'
    })
  }
}
</script>
